// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"353e7c66","455":"d061a383","977":"fe76c467"}[chunkId] + ".chunk.js";
};